import { VantagePointConfig as _VantagePointConfig } from '../../../shared-models/public/vantage-point-config';

export class VantagePointConfig extends _VantagePointConfig {
}

export namespace VantagePointConfig {
    export import RestTypes = _VantagePointConfig.RestTypes;
}
